import { render, staticRenderFns } from "./UserAgent.vue?vue&type=template&id=004b4fb2&scoped=true&"
import script from "./UserAgent.vue?vue&type=script&lang=js&"
export * from "./UserAgent.vue?vue&type=script&lang=js&"
import style0 from "./UserAgent.vue?vue&type=style&index=0&id=004b4fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004b4fb2",
  null
  
)

component.options.__file = "UserAgent.vue"
export default component.exports